











































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Form } from '@ss/mtd-vue';
import moment from 'moment';
import * as api from '@/api';
import { get, findIndex, keys, cloneDeep } from 'lodash';
import VueClipboards from 'vue-clipboards';
import * as validators from '@/utils/validator';
Vue.use(VueClipboards);
// const defaultOption = [
//     {
//         orgId: 0,
//         orgPath: '可从大象个人名片中查找完整部门链，部门链至少三级(如：美团/基础研发平台/研发质量及效率部)',
//         disabled: true,
//         orgName: ''
//     }
// ];

@Component({
    name: 'Catalog'
})
export default class Catalog extends Vue {
    @Prop()
    level: number;
    @Prop()
    node: any;
    @Prop()
    currentCatalog: any;
    @Prop()
    edit: boolean;
    @Prop()
    noChildren: boolean;

    ruleCustom: any = {
        name: {
            validator: validators.validateName100,
            required: true
        }
    };
    templateOptions: any = [];
    rgOptions: any = [];
    enable: boolean = false;
    editable: boolean = false;
    templateType: string = '';
    formCustom: any = {
        id: '',
        name: '',
        state: 1,
        ticketRelated: true,
        defaultCatalog: '',
        defaultItemId: '',
        rgId: '',
        templateId: null,
        createdBy: '',
        createdAt: (() => {
            return new Date();
        })(),
        ticketCreateLink: '',
        mainSpaceVisible: false
    };
    // authActive:boolean = false;
    loading: boolean = false;
    loading1: boolean = false;
    loadingRg: boolean = false;
    loadingTemplate: boolean = false;
    options: any = [];
    level3Options: any = [];
    oldFormCustom: any = {};

    get createdTime() {
        return moment(this.formCustom.createdAt).format('YYYY-MM-DD HH:mm:ss');
    }

    @Watch('formCustom.defaultCatalog')
    level3Hanlder(val) {
        if (val) {
            this.initLevel3Options(val);
        }
    }

    @Watch('formCustom.rgId')
    rgIdHandler(val) {
        this.initRgOption(val);
        this.findTemplate();
    }

    @Watch('formCustom.templateId')
    templateIdHandler() {
        if (this.formCustom.rgId) {
            this.findTemplate();
        }
    }

    @Watch('edit', { immediate: true })
    editHandler(val) {
        this.editable = val;
        if (val && this.options.length === 0) {
            this.initOptions();
        }
    }

    created() {
        this.formCustom = this.currentCatalog;
        this.oldFormCustom = cloneDeep(this.currentCatalog);
        this.initOptions();
    }

    rgIdChangedHandler() {
        this.formCustom.templateId = 0;
    }

    linkFilter(link: string) {
        if (!link) {
            return '';
        }
        return link.replace(/\+/g, '%2B');
    }

    handleCopySuccess() {
        this.$mtd.message({
            message: '复制TT链接成功',
            type: 'success'
        });
    }

    templateChangeHandler(val) {
        this.formCustom.templateId = val;
        const index = findIndex(this.templateOptions, item => {
            return item.id === val;
        });
        this.formCustom.templateType = this.templateOptions[index].type;
    }

    toggleState(val) {
        let msg = '当前目录停用后，下级目录跟随停用';
        msg = val === 2 ? msg : '当前目录启用后，上级目录跟随启用';
        this.$mtd.message.info(msg);
    }

    async initRgOption(query) {
        this.loadingRg = true;
        let params = null;
        if (!query) {
            params = {
                spaceId: this.$route.params.id
            };
        } else if (isNaN(query)) {
            params = {
                spaceId: this.$route.params.id,
                name: query
            };
        } else {
            params = {
                spaceId: this.$route.params.id,
                id: query
            };
        }
        const res = await api.ctiApi.getAllSpaceRg(params);
        this.rgOptions = get(res, ['data', 'items'], []);
        this.loadingRg = false;
    }

    async findTemplate() {
        this.loadingTemplate = true;
        let res = {};
        if (this.formCustom.rgId) {
            res = await api.rgApi.getRgTemplateList({
                rgId: this.formCustom.rgId,
                sn: 100
            });
        }
        this.loadingTemplate = false;
        this.templateOptions = get(res, ['data', 'items'], []).concat({ id: 0, name: '无', type: '' });
    }

    async initOptions() {
        if (this.currentCatalog && this.currentCatalog.id) {
            this.options = await this.getChildTreeData(this.level - 1, this.currentCatalog.id);
            this.enable = !!this.options.length;
        } else {
            this.enable = false;
        }
    }

    async initLevel3Options(id) {
        this.level3Options = await this.getChildTreeData(1, id);
    }

    resetForm() {
        const formKeys = keys(this.formCustom);
        (this.$refs.formCustom as Form).resetFields(formKeys);
        this.editable = false;
    }

    makeEdit() {
        this.editable = true;
        this.oldFormCustom = cloneDeep(this.currentCatalog);
    }

    async validateForm() {
        return new Promise((resolve, reject) => {
            (this.$refs.formCustom as Form)
                .validate(valid => {
                    if (valid) {
                        resolve('ok');
                    } else {
                        const e = new Error('校验未通过');
                        reject(e);
                    }
                })
                .catch(e => e);
        }).catch();
    }

    async handleSubmit() {
        const v = await this.validateForm();
        if (v === 'ok') {
            if (this.level === 1) {
                this.formCustom.defaultItemId = this.formCustom.defaultLevel3;
            } else {
                this.formCustom.defaultItemId = this.formCustom.defaultCatalog;
            }
            this.$emit('updateCatalog', this.formCustom, this.level, this.node);
            this.editable = false;
        }
    }

    async getChildTreeData(level, parentId) {
        let childList;
        if (level === 0) {
            childList = await api.ctiApi.getCatalogLevel2Tree({ parentId, states: 1 });
        } else if (level === 1) {
            childList = await api.ctiApi.getCatalogLevel3Tree({ parentId, states: 1 });
        } else {
            return [];
        }
        return get(childList, ['data', 'items'], []);
    }

    async remoteMethod(query) {
        console.log(query);
    }

    formatter(val) {
        if (val.value) {
            return `${val.value.orgName}`;
        }
    }
}
